import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { User } from 'generated-graphql/types';
import { userAtom } from 'services/user/atoms';
import { PYLON_APP_ID } from './constants';
import { loadPylonScript } from './loadPylonScript';

declare global {
  interface Window {
    Pylon?: any;
    pylon?: {
      chat_settings: {
        app_id: string;
        email: string;
        name: string;
        avatar_url?: string;
      };
    };
  }
}

/**
 * Gets the user's full name with fallback logic
 * @param user - The user object
 * @returns The user's display name (name, constructed from firstName/lastName, or email)
 */
const getUserFullName = (user: User): string => {
  return (
    user.name ||
    [user.firstName, user.lastName].filter(Boolean).join(' ') ||
    user.email
  );
};

export const usePylonWidget = () => {
  const user = useRecoilValue(userAtom);

  useEffect(() => {
    if (!user) return;

    const initializePylon = async () => {
      try {
        // Load the Pylon script first
        await loadPylonScript();

        // Configure the widget with user data
        window.pylon = {
          chat_settings: {
            app_id: PYLON_APP_ID,
            email: user.email,
            name: getUserFullName(user)
          }
        };
      } catch (error) {
        console.error('Failed to initialize Pylon widget:', error);
      }
    };

    initializePylon();
  }, [user]);
};
